jQuery('.open-modal a').fancybox({
  afterShow: function() {
    jQuery("input[name=fcname]").focus();
  }
});